import { all, fork } from 'redux-saga/effects';

import baseSaga from './base';

export default function* sagas() {
  yield all([fork(baseSaga)]);
}
